import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { FeedbackApi } from 'api';

function useGet(id: string) {
  return useAuthQuery(
    getQueryKeys([KEY]).detail(id),
    () => FeedbackApi.get(id),
    {
      select: (data) => data.data,
      enabled: !!id,
    },
  );
}

export default useGet;
